import TableRow from '@mui/material/TableRow';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import IconTooltipButtom from '../../../../button/IconTooltipButton';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '../../../../progress/LinearProgress';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import { Alert, Typography } from '@mui/material';
import './FileUploaderPreviewList.css';

const determineFileIcon = (file) => {
  const extension = file?.name?.split('.').pop();

  switch (extension) {
    case 'pdf':
      return 'fa-light fa-file-pdf';
    case 'doc':
    case 'odt':
    case 'docx':
      return 'fa-light fa-file-word';
    case 'xls':
    case 'xlsx':
      return 'fa-light fa-file-spreadsheet';
    case 'ppt':
    case 'pptx':
      return 'fa-light fa-file-powerpoint';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'webp':
      return 'fa-light fa-file-image';
    case 'mp4':
    case 'mkv':
      return 'fa-light fa-file-video';
    default:
      return 'fa-light fa-file';
  }
};

const FileUploaderPreviewList = ({
  files,
  isLoading,
  uploaded = [],
  onUploadFile,
  onDeleteFile,
  uploadFiles,
  pendingToUpload,
  percent,
  error,
  currentUpload
}) => {
  const filesToUpload = files.filter((file) => !file?.alreadyAdded);

  return (
    <aside
      className='flex flex-col absolute bottom-0 inset-x-0 overflow-auto  top-52'
      style={{ overflow: 'hidden', overflowY: 'auto', marginBottom: '5rem' }}
    >
      <div className='w-full'>
        {isLoading && (
          <>
            <LinearProgress value={percent} />
            {currentUpload && <div className='text-muted-foreground text-sm'>Uploading {currentUpload}</div>}
          </>
        )}
        {!isLoading && percent === 100 && (
          <Typography className='px-2'>
            {uploaded?.filter((el) => !el.error)?.length}/{files?.length} Files uploaded.
          </Typography>
        )}
        {error && <Alert severity='error'>{error}</Alert>}
      </div>
      <div className='px-2 h-10 bg-background sticky top-0px text-xl text-right text-primary z-1 upload-progress__container'>
        <span className='text-xl text-right text-primary'> Selected Files: {filesToUpload?.length}</span>
        <ButtonStartIcon
          color='primary'
          variant='contained'
          startIcon={['fas', 'upload']}
          loading={false}
          onClick={uploadFiles}
          disabled={isLoading || pendingToUpload?.length === 0}
          style={{
            height: '40px'
          }}
        >
          Upload Files
        </ButtonStartIcon>
      </div>

      {files.map((file, index) => {
        const { isUploading } = file;
        const fileUploaded = uploaded.find((item) => item.name === file.name);
        return (
          <TableRow
            component={'div'}
            key={index}
            className='px-4 py-1 flex gap-4 items-center justify-between'
            style={{ backgroundColor: file?.alreadyAdded ? 'transparent' : 'rgb(222 237 248)' }}
          >
            <div className='flex items-center gap-1 text-center'>
              <span className='max-w-50px min-w-50px'>{index + 1}</span>
              <FontAwesomeIcon icon={determineFileIcon(file)}  className='preview-list__file-icon' />
            </div>
            <div className='max-w-250px min-w-250px'>{file.name}</div>
            <div className='max-w-150px min-w-150px'>{file.size / 1000} KB</div>
            <div className='max-w-50px min-w-50px text-right'>
              {isLoading ? (
                <>
                  {fileUploaded ? (
                    fileUploaded.error ? (
                      <Tooltip title={fileUploaded.error} placement='top' arrow>
                        <FontAwesomeIcon
                          icon='exclamation-triangle'
                          className='text-secondary cursor-pointer'
                        />
                      </Tooltip>
                    ) : (
                      <FontAwesomeIcon icon='check' color='green' />
                    )
                  ) : (
                    <FontAwesomeIcon icon='spinner' spin />
                  )}
                </>
              ) : (
                <div style={{ display: 'flex', gap: '5px' }}>
                  {file?.alreadyAdded ? (
                    <a href={file?.link} download={`${file?.name}`}>
                      <IconTooltipButtom
                        id={`download-${file.name}`}
                        title='Download'
                        icon={['fas', 'download']}
                      />
                    </a>
                  ) : (
                    <>
                      {isUploading ? (
                        <Box sx={{ display: 'flex' }}>
                          <CircularProgress size={20} />
                        </Box>
                      ) : (
                        <IconTooltipButtom
                          id={`upload-${file.name}`}
                          title='Upload'
                          icon={['fas', 'upload']}
                          onClick={() => onUploadFile(file)}
                        />
                      )}
                    </>
                  )}
                  <IconTooltipButtom
                    id={`delete-${file.name}`}
                    title={file?.alreadyAdded ? 'Delete' : 'Remove'}
                    icon={file?.alreadyAdded ? 'trash-alt' : 'close'}
                    onClick={() => onDeleteFile(file)}
                  />
                </div>
              )}
            </div>
          </TableRow>
        );
      })}
    </aside>
  );
};

export default FileUploaderPreviewList;
